import React from 'react';
import PropTypes from "prop-types";

import {styled} from "@mui/material/styles";

import {ReactComponent as ArrowDown} from "assets/img/arrow-down.svg";
import {greyishBlue300} from "assets/jss/main";

ArrowDownIcon.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.number,
};

const StyledSvg = styled(ArrowDown)(({ theme, color, disabled, size}) => ({
    ...size && {
        width: size,
        height: size
    },
    'path': {
        ...color !== null && {
            fill: color
        },
        ...disabled === true &&  {
            fill: greyishBlue300
        }
    },
}));

export default function ArrowDownIcon(props) {
    return <StyledSvg {...props} />;
}
